import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function userInfoReducer(state = initialState.userInfo, action) {
  switch (action.type) {
    case types.LOAD_USER_INFO_STARTED:
      return {
        ...initialState.userInfo,
        isLoaded: false,
        loading: true
      }

    case types.LOAD_USER_INFO_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isLoaded: true,
        loading: false
      }

    default:
      return state;
  }
}
